import type { ProductType } from "@/generated/graphql"
import React from "react"
import {
  type CapitalProductSlug,
  getCapitalProductNameBySlug,
} from "@/screens/loans/utils/LoanCapitalProducts"
import { Pressable, View } from "react-native"
import GoldTrophy from "@/assets/clipart/gold-standard-trophy.svg"
import Rocket from "@/assets/clipart/rocket.svg"
import RefiKeys from "@/assets/clipart/refi-keys.svg"
import DoubleDouble from "@/assets/clipart/double-double-bills.svg"
import { H6 } from "@/components/standard/BFText"
import LoanSelectedIcon from "@/assets/icons/loan-selected.svg"

interface LoanProductButtonProps {
  cardData: ProductType
  isShown: boolean
  isSelected: boolean
  onPress: () => void
}

function ProductClipArt({ slug }: { slug: CapitalProductSlug }) {
  switch (slug) {
    case "standard":
    case "standard_combined":
      return <GoldTrophy height={"100%"} />

    case "zero_gravity":
      return <Rocket height={"100%"} />

    case "refinance_rehab":
      return <RefiKeys height={"100%"} />
  }

  // Double-double, default
  return <DoubleDouble />
}
export const LoanProductButton = ({
  cardData,
  isShown,
  isSelected,
  onPress,
}: LoanProductButtonProps) => {
  const productSlug = cardData.product as CapitalProductSlug

  const title: string = getCapitalProductNameBySlug(productSlug) || "N/A"
  const isSelectable =
    cardData.isSelectable || cardData.product === "standard_combined" || false

  return (
    <Pressable
      testID={`select-loan-product-${title}`}
      className={`max-h-[250px] h-[100px] min-w-[100px] overflow-hidden relative p-2 gap-4 flex-1 rounded-md items-center justify-between border ${isShown ? "border-midnight-blue bg-grey" : "border-light-grey"}`}
      onPress={onPress}
    >
      <View className={"flex-1 w-full items-center justify-center"}>
        <ProductClipArt slug={productSlug} />
      </View>
      <H6
        className={
          !isSelectable ? "text-wire-frames-grey" : "text-midnight-blue"
        }
      >
        {title}
      </H6>
      {isSelected && (
        <View className={"absolute top-2 right-2"}>
          <LoanSelectedIcon />
        </View>
      )}
    </Pressable>
  )
}
